import { render, staticRenderFns } from "./OChip.vue?vue&type=template&id=99463a88&scoped=true"
import script from "./OChip.vue?vue&type=script&lang=js"
export * from "./OChip.vue?vue&type=script&lang=js"
import style0 from "./OChip.vue?vue&type=style&index=0&id=99463a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99463a88",
  null
  
)

export default component.exports